module.exports = __webpack_public_path__ + "static/img/more_hover.3e075e88.svg";